import { createSingleFlightScope, useSingleFlight } from '../../lib/hooks/use-single-flight';
import { AGE_GROUP_REPORT_CARD_WRITES } from './report-card-access.constants';
import { ageGroupWriteKey } from './report-card-access.helpers';
import { AgeGroupReportCardWrite } from './report-card-access.types';

// Module-level so the panel and the send dialog see each other's writes, and a remount can't repeat one.
const REPORT_CARD_AGE_GROUP_WRITES = createSingleFlightScope();

// One age-group write, single-flight per age group. `busy` is true while any of the age group's writes
// runs, so a send, a setting change and a revoke never overlap from the UI.
export const useAgeGroupWriteFlight = <Args extends unknown[], Result>(
  ageGroupId: string,
  write: AgeGroupReportCardWrite,
  action: (...args: Args) => Promise<Result>,
) => {
  const flight = useSingleFlight(action, { scope: REPORT_CARD_AGE_GROUP_WRITES, key: () => ageGroupWriteKey(ageGroupId, write) });
  const { run, isInFlight } = flight;

  return {
    run,
    inFlight: isInFlight(ageGroupWriteKey(ageGroupId, write)),
    busy: AGE_GROUP_REPORT_CARD_WRITES.some(other => isInFlight(ageGroupWriteKey(ageGroupId, other))),
  };
};
